(function() {

	'use strict';

	/**
	 * Selectors
	 */

	var svgSymbols = '/sprite.svg';
	var gallery = document.querySelector('[data-gallery]');

	/**
	 * Methods
	 */

	// Get closets matching parent
	var getClosest = function (elem, selector) {
		var firstChar = selector.charAt(0);
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( firstChar === '.' ) {
				if ( elem.classList.contains( selector.substr(1) ) ) {
					return elem;
				}
			}
			if ( firstChar === '#' ) {
				if ( elem.id === selector.substr(1) ) {
					return elem;
				}
			}
			if ( firstChar === '[' ) {
				if ( elem.hasAttribute( selector.substr(1, selector.length - 2) ) ) {
					return elem;
				}
			}
			if ( elem.tagName.toLowerCase() === selector ) {
				return elem;
			}
		}
		return false;
	};

	// Throttle events
	var throttle = function( callback, limit ) {
		var wait = false;
		return function () {
			if ( !wait ) {
				callback.call();
				wait = true;
				setTimeout(function () {
					wait = false;
				}, limit );
			}
		};
	};

	// Handle click events
	var clickEventHandler = function(e) {

		// Get closest anchor
		var anchor = getClosest( e.target, 'a' );

		// Gallery nav
		if (anchor && anchor.hasAttribute('data-gallery-nav') ) {
			e.preventDefault();
			var direction = anchor.getAttribute('data-gallery-nav');
			var gallery = getClosest( e.target, '[data-gallery]' );
			var flkty = Flickity('.gallery');

			if (direction == 'next') {
				flkty.next();
			} else {
				flkty.previous();
			}
		}
	};


	/**
	 * Events/APIs/init
	 */

	var loadSvg = function () {
		var ajax = new XMLHttpRequest();
		ajax.open('GET', svgSymbols, true);
		ajax.send();
		ajax.onload = function() {
			var div = document.createElement('div');
			div.style.display = 'none';
			div.innerHTML = ajax.responseText;
			document.body.insertBefore(div, document.body.childNodes[0]);
		};
	};

	loadSvg();

	var trigger = new ScrollTrigger({
		toggle: {
			visible: 'is-visible',
			hidden: 'is-hidden'
		},
		offset: {
			x: 0,
			y: 200
		},
		once: true
	}, document.body, window);

	if (gallery) {
		var flkty = new Flickity(gallery, {
			cellAlign: 'left',
			pageDots: false,
			prevNextButtons: false,
			wrapAround: true
		});
	}

	window.addEventListener('click', clickEventHandler, false);

})();